import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ExpandableText } from "web_myplann/Shared/Components/ExpandableText";

type Props = {
	title: string;
	content: string;
	showDivider: boolean;
};

export const ActivityNoteBlock: FC<Props> = ({
	title,
	content,
	showDivider,
}) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack
			px={spacingTokens.lg}
			py={spacingTokens.md}
			gap={spacingTokens.xs}
			borderBottom={showDivider ? 1 : 0}
			borderColor="surface.border"
		>
			{title && <Typography variant="bodyStrong">{title}</Typography>}
			{content && <ExpandableText text={content} color={palette.grey[700]} />}
		</Stack>
	);
};
